import { drawerReducer } from '@/core/features/drawer';
import { modalReducer } from '@/core/features/modal';
import { snackbarReducer } from '@/core/features/snackbar';
import { loaderReducer } from '@/core/features/loader';
import { userReducer } from '@/slices/user';
import { dashboardReducer } from '@/slices/dashboard';
import { eventsReducer } from '@/slices/events';
import { membersReducer } from '@/slices/members';

export default {
  drawer: drawerReducer,
  modal: modalReducer,
  snackbar: snackbarReducer,
  loader: loaderReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  events: eventsReducer,
  members: membersReducer,
};
